// extracted by mini-css-extract-plugin
export var pillWrapper = "_j3-0";
export var showOverflow = "_j3-1";